import React from 'react';
import '../../../../css/common/chat/SystemMessageCard.css';

export const SystemMessageCardHeader = ({
  title = '',
  showIcon = false,
  iconClass = 'fa-bullhorn',
  badge = '',
}) => (
  <div className={`system-message-card__header${showIcon ? '' : ' system-message-card__header--noicon'}`}>
    {showIcon ? (
      <span className="system-message-card__header-icon" aria-hidden="true">
        <i className={`fa-solid ${iconClass}`} aria-hidden="true" />
      </span>
    ) : null}
    <span className="system-message-card__header-title">{title}</span>
    {badge ? <span className="system-message-card__header-badge">{badge}</span> : null}
  </div>
);

const SystemMessageCard = ({
  title = '',
  showIcon = false,
  iconClass = 'fa-bullhorn',
  badge = '',
  className = '',
  addNoIconClass = true,
  bodyClassName = 'system-message-card__body',
  children = null,
}) => {
  const rootClassName = [
    'system-message-card',
    addNoIconClass && !showIcon ? 'system-message-card--noicon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClassName}>
      <SystemMessageCardHeader
        title={title}
        showIcon={showIcon}
        iconClass={iconClass}
        badge={badge}
      />
      <div className={bodyClassName}>{children}</div>
    </div>
  );
};

export default SystemMessageCard;
